<template>
  <v-btn
    :disabled="disabled"
    :loading="loading"
    class="button button-apply"
    width="100%"
    color="#4caf50"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot name="icon">
      <font-awesome-icon icon="check" />
    </slot>
    <slot>
      Применить
    </slot>
  </v-btn>
</template>

<script>
  export default {
    name: 'BigApplyBtn',
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped lang="less">
.button-apply {
  background-color: @color-success !important;
  color: #ffffff;

  svg {
    margin-right: 8px;
    .fill-svg(#ffffff);
  }
}
</style>
